import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const CHAT: ObjectTypeConfig = {
  actions: [
    {
      id: "open",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "star",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.isFavorite,
    },
    {
      id: "unstar",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: { not: predicates.isFavorite },
    },
    {
      id: "rename",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "delete",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
  ],
};
